import { render, staticRenderFns } from "./Turnover.vue?vue&type=template&id=a08d3e02&"
import script from "./Turnover.vue?vue&type=script&lang=js&"
export * from "./Turnover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports